import { CardSvg } from '@/play/cardSvg'

const DRIPS: ReadonlyArray<readonly [number, number, number, string]> = [
  // x, length, width, colour
  [40, 70, 7, '#7ee35b'],
  [78, 40, 6, '#7ee35b'],
  [112, 96, 8, '#ffe53a'],
  [150, 55, 6, '#ff5fa2'],
  [186, 82, 7, '#ff5fa2'],
  [222, 34, 6, '#3fb8ff'],
  [256, 66, 7, '#a66bff'],
]

/**
 * Home card art for Drip wall: a band of goo along the top of a white wall, drips with bulbs; the
 * page's soft sky (blue to lavender to pink, DRIP_SKY) around the wall.
 */
export function DripWallCardArt() {
  return (
    <CardSvg bg="#cfd2fa">
      {(id) => (
        <>
          <defs>
            <linearGradient id={id('sky')} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#a9dcf7" />
              <stop offset="0.55" stopColor="#cfd2fa" />
              <stop offset="1" stopColor="#f6d3e8" />
            </linearGradient>
          </defs>
          <rect width="320" height="200" fill={`url(#${id('sky')})`} />
          <rect x="8" y="14" width="304" height="164" fill="#ffffff" />
          <rect x="8" y="178" width="304" height="10" fill="#e3e9f3" />
          {DRIPS.map(([x, len, w, c]) => (
            <g key={x} fill={c}>
              <path d={`M ${x - w} 40 C ${x - w * 0.5} 52, ${x - w * 0.45} ${40 + len * 0.6}, ${x - w * 0.5} ${40 + len} L ${x + w * 0.5} ${40 + len} C ${x + w * 0.45} ${40 + len * 0.6}, ${x + w * 0.5} 52, ${x + w} 40 Z`} />
              <circle cx={x} cy={44 + len} r={w * 1.15} />
            </g>
          ))}
          <path d="M 14 30 C 60 18, 110 44, 160 30 S 260 20, 306 32 L 306 46 C 260 40, 220 52, 160 44 S 60 52, 14 44 Z" fill="#7ee35b" />
          <path d="M 100 32 C 130 26, 160 36, 190 30 L 192 44 C 160 50, 130 40, 100 46 Z" fill="#ff5fa2" />
          <path d="M 200 30 C 230 24, 250 34, 270 28 L 272 42 C 250 48, 230 40, 200 45 Z" fill="#3fb8ff" />
          <ellipse cx="60" cy="31" rx="18" ry="3" fill="#ffffff" opacity="0.55" />
        </>
      )}
    </CardSvg>
  )
}
